import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  tags: { [key: string]: string } = {}
  title: string = ''
  keysToTranslate: string[] = ['og:description', 'description', 'title'];

  constructor(public meta: Meta,
    public titleService: Title,
    private translate: TranslateService,) { }

    setTag(key: string, text: string) {
      if(text == null)
        return
      this.tags[key] = text;
      this.meta.updateTag({ property: key, content: this.tags[key] && this.keysToTranslate.includes(key) ? this.translate.instant(this.tags[key]): this.tags[key] }); 
    }

    setTitle(text: string) {
      if(text == null)
        return
      this.title = text;
      this.titleService.setTitle(this.title ? this.translate.instant(this.title): '');
    }

    getTag(key: string) {
      if(this.tags[key] != undefined)
        return this.tags[key];
      return '';
    }

    getTitle() {
      return this.title;
    }

    updateLang() {
      this.titleService.setTitle(this.title ? this.translate.instant(this.title): '');
      for(var key of this.keysToTranslate) {
        if(this.tags[key] != undefined)
          this.meta.updateTag({ property: key, content: this.translate.instant(this.tags[key]) }); 
      }
    }
}
